import React, { useState, useRef, useEffect } from "react";
import "./MultiDropdown.css";
import { ToastContainer, toast } from "react-toastify";

const MultiDropdown = ({
  label,
  options,
  selectedValues,
  onSelect,
  chips,
  searchable = false,
  onAddNewOption, // Callback to add a new option
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen && searchable && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen, searchable]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    setSearchTerm("");
    onSelect(value);
  };

  const handleChipRemove = (value) => {
    onSelect(value);
  };

  const renderSelectedChips = () => {
    let chipscount = 2;
    if (chips !== "") {
      chipscount = chips;
    }

    const visibleChips = selectedValues.slice(0, chipscount);
    const additionalCount = selectedValues.length - visibleChips.length;

    return (
      <>
        {visibleChips.map((value) => (
          <div
            key={value}
            className="chipmulti"
            onClick={() => handleChipRemove(value)}
          >
            {options.find((option) => option.value === value)?.label || value}
            <span className="closebtn ml12">&times;</span>
          </div>
        ))}
        {additionalCount > 0 && (
          <div className="chipmulti more-chip" onClick={toggleDropdown}>
            +{additionalCount}
          </div>
        )}
      </>
    );
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleAddEmail = () => {
    if (!searchTerm) return;

    if (!isEmailValid(searchTerm)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (onAddNewOption) {
      onAddNewOption(searchTerm);
      setSearchTerm("");
    }
  };

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedValues.length > 0 ? renderSelectedChips() : `Select ${label}`}
      </div>
      {isOpen && (
        <div className="dropdown-menus">
          {searchable && (
            <input
              type="text"
              placeholder="Search or add emails"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="dropdown-search-input"
              ref={searchInputRef}
            />
          )}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.value}
                onClick={() => handleOptionClick(option.value)}
                className={`dropdown-item lh18 ${
                  selectedValues.includes(option.value) ? "selected" : ""
                }`}
              >
                {option.label}
              </div>
            ))
          ) : (
            <div className="no-data-found p10 box-center">No data found</div>
          )}

          {searchTerm &&
            !options.some(
              (option) =>
                option.label.toLowerCase() === searchTerm.toLowerCase()
            ) && (
              <div
                className="dropdown-item add-new-item"
                onClick={handleAddEmail}
              >
                Add "{searchTerm}"
              </div>
            )}
        </div>
      )}
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default MultiDropdown;
